// extracted by mini-css-extract-plugin
export default {"container":"ClientAppointmentBtn_container__dNVd7","appointmentBtn":"ClientAppointmentBtn_appointmentBtn__3Nnkd"};